<template>
  <div>
    <div :class="$style.topbar">
      <Logo v-if="settings.menuLayoutType === 'nomenu'" />
      <div class="mr-auto">
        <TopMenu />
      </div>
      <div class="mr-4 d-none d-sm-block">
        <Actions />
      </div>
      <div>
        <UserMenu />
      </div>
    </div>
    <!-- <SubMenu /> -->
  </div>
</template>

<script>
import store from "store";
import { mapState } from "vuex";

import Logo from "../Logo/index";
import Actions from "./Actions";
import UserMenu from "./UserMenu";
import SubMenu from "./SubMenu";
import TopMenu from "./TopMenu";

export default {
  components: {
    Logo,
    Actions,
    UserMenu,
    TopMenu,
    // SubMenu,
  },
  data() {
    return {
      menuData: [],
      selectedKeys: [],
      openKeys: [],
      visible: false,
    };
  },
  computed: {
    ...mapState(["settings"]),
  },
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
